const Alignment = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};

export default Alignment;
